import React, { useMemo } from 'react';

import { Stack, StarOutlineIcon, Rating, Typography } from '@gogame/components';
import { useFormat } from '@gogame/intl-ts';

import AverageRating from './AverageRating';

export const ReviewsSummary = ({ rating, data, isLoading, variant }) => {
  const format = useFormat({
    type: 'decimal',
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    empty: '-',
  });

  const formattedRating = useMemo(() => format(rating), [rating]);

  const variantIsColumn = variant === 'column';

  return (
    <Stack
      spacing={variantIsColumn ? 0 : 1}
      direction={variantIsColumn ? 'column' : 'row'}
    >
      <Typography variant={variantIsColumn ? 'h5' : 'body1'}>
        {formattedRating}
      </Typography>
      <Stack spacing={1} direction={'row'}>
        <Rating
          value={rating}
          readOnly
          precision={0.1}
          emptyIcon={<StarOutlineIcon sx={{ fontSize: 18 }} />}
        />
        <AverageRating
          rating={formattedRating}
          data={data}
          isLoading={isLoading}
        />
      </Stack>
    </Stack>
  );
};
